module.exports = {
      id: "google-plain-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#google-plain",
      toString: function () {
        return this.url;
      }
    }